/**
 * mx-lazy-section.js — lazy-loads featured-collection carousels on scroll.
 *
 * A `[data-lazy-src]` placeholder (rendered by featured-collection in lazy mode)
 * has its products fetched only when scrolled near the viewport, via the
 * collection's `?view=carousel-fragment` template. The fetched markup is a full
 * <carousel-slider> element, which auto-initialises through its connectedCallback
 * when inserted, and whose product cards are auto-tracked by the GTM impression
 * MutationObserver.
 *
 * Why: keeps those products OUT of the server-rendered (cacheable) document, so
 * their inventory/price churn no longer invalidates the homepage cache — and they
 * aren't fetched at all until needed.
 */
(function () {
  'use strict';

  function load(el) {
    var src = el.getAttribute('data-lazy-src');
    if (!src || el.hasAttribute('data-lazy-loaded')) return;
    el.setAttribute('data-lazy-loaded', '1');
    fetch(src, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var trimmed = (html || '').trim();
        if (!trimmed) return;
        // Replace the placeholder container with the fetched carousel. Inserting
        // the <carousel-slider> into the DOM triggers its connectedCallback (init).
        var target = el.closest('.container') || el;
        target.insertAdjacentHTML('beforebegin', trimmed);
        target.remove();
        document.dispatchEvent(new CustomEvent('on:lazy-section:loaded'));
      })
      .catch(function () { el.removeAttribute('data-lazy-loaded'); });
  }

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { obs.unobserve(e.target); load(e.target); }
        });
      }, { rootMargin: '600px 0px' })
    : null;

  function scan() {
    document.querySelectorAll('[data-lazy-src]:not([data-lazy-loaded])').forEach(function (el) {
      if (io) io.observe(el); else load(el);
    });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
})();
